/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Staples_HelpInputs */

const en_shopping_staples_help = /** @type {(inputs: Shopping_Staples_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always at home, so they stay off the list. When one runs low, turn on “Restock”: it goes on the list until you check it off.`)
};

const de_shopping_staples_help = /** @type {(inputs: Shopping_Staples_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hast du immer zu Hause, darum stehen sie nicht auf der Liste. Wird etwas knapp, schalte „Nachkaufen“ ein: Es kommt auf die Liste, bis du es abhakst.`)
};

/**
* | output |
* | --- |
* | "Always at home, so they stay off the list. When one runs low, turn on “Restock”: it goes on the list until you check it off." |
*
* @param {Shopping_Staples_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_staples_help = /** @type {((inputs?: Shopping_Staples_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Staples_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_staples_help(inputs)
	return en_shopping_staples_help(inputs)
});